import gsap from 'gsap';
import { ScrollToPlugin } from 'gsap/ScrollToPlugin';
import mapboxgl from 'mapbox-gl';
import { ev, isMobile } from '../../utils';
import { contentMap } from './data-business';

const headerOffset = 80;

// import { isTouchDevice } from '../utils';

class Map {
	constructor() {
		this.initialized = false;
	}

	createMap() {
		const mapHolder = document.querySelector('[data-quiz="map"]');
		if (!mapHolder) return;

		const zoom = isMobile ? 2 : 3.66;

		mapboxgl.accessToken =
			'pk.eyJ1IjoiY25uZGlnaXRhbCIsImEiOiJiYjIwMTgxNDZmNjgyODllMjAxYTYwOTAxYmY2MzI2MyJ9.8F6TQITXymFzCXy8tBqGgg';

		//console.log('window.currentMapContent[0].mapCenter', window.currentMapContent[0].mapCenter);
		//console.log('window.currentMapContent[0]', window.currentMapContent[0]);

		const map = new mapboxgl.Map({
			container: mapHolder,
			style: 'mapbox://styles/cnndigital/clp6i6uem01lf01pm8k4ebizq',
			center: window.currentMapContent[0].mapCenter,
			minZoom: zoom,
			maxZoom: 4.66,
			zoom: 2,
			// zoom: 12,
			projection: 'naturalEarth',
		});

		this.initialized = true;

		map.addControl(
			new mapboxgl.NavigationControl({
				showCompass: false,
			}),
			'bottom-right',
		);

		window.map = map;

		let selectedCountry = '';

		const correctCountries = [];
		const wrongCountries = [];

		map.on('load', function () {
			const layers = map.getStyle().layers;
			// Find the index of the first symbol layer in the map style.
			let firstSymbolId;
			for (const layer of layers) {
				if (layer.type === 'symbol' && layer.layout && layer.layout['text-field']) {
					// console.log(layer.id);
				}
				console.log(layer);
				if (layer.type === 'symbol') {
					firstSymbolId = layer.id;
					break;
				}
			}

			firstSymbolId = 'admin-0-boundary';
			map.addSource('cbs', {
				// country-boundaries-simplified
				type: 'geojson',
				data: 'https://d2ad6b4ur7yvpq.cloudfront.net/naturalearth-3.3.0/ne_50m_admin_0_countries.geojson',
				// data: '../js/countries.geo.json',
			});

			map.addLayer(
				{
					id: 'cf', // country-fills
					type: 'fill',
					source: 'cbs',
					paint: {
						'fill-color': '#627BC1',
						'fill-opacity': 0,
					},
				},
				firstSymbolId,
			);

			map.addLayer(
				{
					id: 'cfh', // country-fills-hover",
					type: 'fill',
					source: 'cbs',
					paint: {
						'fill-color': '#EC972D',
						'fill-opacity': 1,
					},
					filter: ['==', 'name', ''],
				},
				firstSymbolId,
			);

			map.addLayer(
				{
					id: 'cfc', // country-fills-click",
					type: 'fill',
					source: 'cbs',
					paint: {
						'fill-color': '#11174A',
						'fill-opacity': 1,
					},
					filter: ['==', 'name', ''],
				},
				firstSymbolId,
			);

			map.addLayer(
				{
					id: 'cfcw', // country-fills-click-wrong",
					type: 'fill',
					source: 'cbs',
					paint: {
						'fill-color': '#E66B6E',
						'fill-opacity': 1,
					},
					filter: ['==', 'name', ''],
				},
				firstSymbolId,
			);

			const setFilterForCountries = (countryName, filterName) => {
				const mapItemCountries = contentMap.filter((item) => {
					return item.nameCountry.includes(countryName);
				});

				if (mapItemCountries.length) {
					const countryFilters = mapItemCountries[0].nameCountry.map((country) => {
						return ['==', 'name', country];
					});

					map.setFilter(filterName, ['any', ...countryFilters]);

					return;
				}

				map.setFilter(filterName, ['==', 'name', countryName]);
			};

			map.on('mousemove', function (e) {
				var features = map.queryRenderedFeatures(e.point, { layers: ['cf'] });

				// console.log(features);
				if (features.length) {
					const hoveredCountryName = features[0].properties.name;
					map.getCanvas().style.cursor = 'pointer';

					setFilterForCountries(hoveredCountryName, 'cfh');
				} else {
					map.setFilter('cfh', ['==', 'name', '']);
					map.getCanvas().style.cursor = '';
				}
			});

			// Reset the state-fills-hover layer's filter when the mouse leaves the map
			map.on('mouseout', function () {
				map.getCanvas().style.cursor = 'auto';
				map.setFilter('cfh', ['==', 'name', '']);
			});

			map.on('click', function (e) {
				var features = map.queryRenderedFeatures(e.point, { layers: ['cf'] });

				if (features.length) {
					selectedCountry = features[0].properties.name;
					console.log(selectedCountry);
					ev('countryClick', {
						countryName: features[0].properties.name,
					});
				}
			});

			document.addEventListener('nextQuestion', (e) => {
				map.setFilter('cfc', ['==', 'name', '']);
				map.setFilter('cfcw', ['==', 'name', '']);

				if (!e.detail.mapCenter) return;

				function getBoundingBox(center, zoom, marginKm) {
					const scale = 1 / Math.pow(2, zoom); // Scale based on zoom level
					const latRadians = (center[1] * Math.PI) / 180;
					const latDegreeDistance = 111.32; // Approximate km per degree of latitude
					const lonDegreeDistance = 111.32 * Math.cos(latRadians); // Varies with latitude

					// Convert scale to distance in km
					const latDistance = scale * latDegreeDistance * 100; // Scale factor for zoom to distance
					const lonDistance = scale * lonDegreeDistance * 100;

					// Calculate changes in latitude and longitude
					const latChange = latDistance / latDegreeDistance;
					const lonChange = lonDistance / lonDegreeDistance;

					// Add extra margin
					const marginLat = marginKm / latDegreeDistance;
					const marginLon = marginKm / lonDegreeDistance;

					console.log(marginLon);

					const southWest = [center[0] - lonChange - marginLon, center[1] - latChange - marginLat];
					const northEast = [center[0] + lonChange + marginLon, center[1] + latChange + marginLat];

					return [southWest, northEast];
				}

				const distance = 2500; // Distance in kilometers from the central point

				const bounds = getBoundingBox([e.detail.mapCenter.lng, e.detail.mapCenter.lat], 3.66, distance);

				console.log(bounds);

				map.setMaxBounds(null);

				map.easeTo({
					center: e.detail.mapCenter,
					curve: 1,
					zoom: e.detail.zoom && isMobile ? e.detail.zoom : zoom,
					duration: 500,
				});

				setTimeout(() => {
					map.setMaxBounds(bounds);
				}, 1000);
			});

			document.addEventListener('selectCountry', (e) => {
				// console.log(e.detail.correctAnswer);
				if (e.detail.isCorrect) correctCountries.push(['==', 'name', selectedCountry]);
				if (!e.detail.isCorrect) wrongCountries.push(['==', 'name', selectedCountry]);
				// map.setFilter('cfc', ['any', ['==', 'name', 'China'], ['==', 'name', 'Lao PDR']]);

				// map.setFilter('cfc', ['==', 'name', e.detail.correctAnswer]);
				setFilterForCountries(e.detail.correctAnswer[0], 'cfc');
				// if (!e.detail.isCorrect) map.setFilter('cfcw', ['==', 'name', selectedCountry]);
				if (!e.detail.isCorrect) setFilterForCountries(selectedCountry, 'cfcw');

				// map.setFilter('cfc', ['any', ...correctCountries]);
				// map.setFilter('cfcw', ['any', ...wrongCountries]);
			});
		});
	}
}

export default function () {
	gsap.registerPlugin(ScrollToPlugin);
	let map = new Map();
	map.createMap();
}
